import css from './copyButton.module.css'
import { CSSProperties, useEffect, useRef, useState } from 'react'
import CopyIcon from '../../../assets/icons/fileCopy.svg?react'
import SmoothPanel from '../../Animated/SmoothPanel'

interface IProps {
  text: string
  messageStyles?: CSSProperties
}

const CopyButton = (props: IProps) => {
  const [msgVisible, setMsgVisible] = useState(false)
  const hideMessageTimeoutRef = useRef<number | null>(null)

  useEffect(() => {
    return () => {
      if (hideMessageTimeoutRef.current) {
        window.clearTimeout(hideMessageTimeoutRef.current)
      }
    }
  }, [])

  const showCopiedMessage = () => {
    setMsgVisible(true)

    if (hideMessageTimeoutRef.current) {
      window.clearTimeout(hideMessageTimeoutRef.current)
    }

    hideMessageTimeoutRef.current = window.setTimeout(() => setMsgVisible(false), 1500)
  }

  const handleShare = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(props.text).then(showCopiedMessage).catch(() => null)
    }
  }

  const button = (
    <button
      type="button"
      className={css.wrapper}
      data-active={msgVisible}
      onClick={handleShare}
      aria-label="Скопировать в буфер обмена"
      title="Скопировать"
    >
      <CopyIcon className={css.icon} />
    </button>
  )

  return (
    <SmoothPanel open={msgVisible} icon={button} transformOrigin="top right" duration={100}>
      <div className={css.message} style={props.messageStyles}>
        Скопировано в буфер обмена
      </div>
    </SmoothPanel>
  )
}

export default CopyButton
